module.exports = __webpack_public_path__ + "static/media/vertical-align-top.67beb56b.svg";